import { createFileRoute, redirect } from "@tanstack/react-router";
import { deskSearch } from "../../lib/desk/search";

/** The old address of the changed list, now a tab of Award medals. OVR's "Open in MSES" links here (`?event=`), so the search is kept. */
export const Route = createFileRoute("/_app/changed")({
	validateSearch: deskSearch,
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/award/changed", search, replace: true });
	},
});
